module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
  title: 'Ivan Pidov', // Navigation and Site Title
  titleAlt: 'Ivan Pidov - Software Developer', // Title for JSONLD
  description: 'Random thoughts...',
  keywords: 'JavaScript, TypeScript, Linux, HTML',
  headline: 'Random thoughts...', // Headline for schema.org JSONLD
  url: 'https://thebalkanfella.com', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  logo: '/logos/logo-1024.png', // Used for SEO
  ogLanguage: 'en_US', // Facebook Language

  // JSONLD / Manifest
  favicon: 'src/favicon.png', // Used for manifest favicon generation
  shortName: 'thebalkanfella', // shortname for manifest. MUST be shorter than 12 characters
  author: 'Ivan Pidov', // Author for schemaORGJSONLD
  themeColor: '#3D63AE',
  backgroundColor: '#EBEDF2',

  twitter: '@thebalkanfella', // Twitter Username
  facebook: 'thebalkanfella', // Facebook Site Name
  googleAnalyticsID: 'UA-149418104-1',

  skipNavId: 'reach-skip-nav', // ID for the "Skip to content" a11y feature
}
